import { createQueryKeys } from '@lukemorales/query-key-factory';

export const b2bPayouts = createQueryKeys('b2bPayouts', {
  adminList: (view: string) => [view],
  adminBatches: null,
  adminDeal: (dealId: string) => [dealId],
  workspace: null,
});
